<template>
	<div>
		<div style="display: flex; align-items: center">
			<div class="leftClick" @click="onClickLeft">
				<van-icon name="../../../static/images/mobile/back.png" />
			</div>
			<van-search v-model="value" show-action placeholder="请输入课程名称" @focus="searchResult">
				<template #action>
					<div @click="onSearch">搜索</div>
				</template>
			</van-search>
		</div>
		<div style="display: flex">
			<van-sidebar v-model="activeKey">
				<van-sidebar-item @click="changeRightList(8012, 8)" title="热门推荐" />
				<van-sidebar-item @click="changeRightList(item.id, '')" v-for="(item, index) in firstLevelColumn" :key="index" :title="item.name" />
			</van-sidebar>
			<div style="flex: 1">
				<template v-if="!!secondLevelOneColumn.length">
					<div class="secondCourse" v-for="(item, index) in secondLevelOneColumn" :key="index">
						<div style="margin-bottom: 0.426667rem">
							{{ item.name }}
						</div>
						<div style="display: flex; flex-wrap: wrap">
							<template v-if="!!item.c">
								<p @click="goCurriculum(item.path)" class="classname classnameAll">全部</p>
								<p @click="goCurriculum(item2.path)" class="classname" v-for="(item2, index) in item.c" :key="index">
									{{ item2.name }}
								</p>
							</template>
						</div>
					</div>
				</template>
				<div class="noData" v-else><p class="classname classnameAll" @click="goCurriculum()">全部</p></div>
			</div>
		</div>
	</div>
</template>
<script>
// import _ from 'lodash'
export default {
	components: {},
	props: {},
	directives: {
		clickDown: {
			inserted(el, binding, index) {
				if (binding.value === 0) {
					el.click();
				}
			},
		},
	},
	data() {
		return {
			value: "", //搜索的内容
			activeKey: 0,
			leftList: [],
			rightList: [],
			firstLevelColumn: [],
			secondLevelOneColumn: [],
			thirdLevelOneColumn: [],
			hotLevelColumn: [],
		};
	},
	computed: {},
	watch: {},
	methods: {
		/**
		 * 初始化课程分类 一级
		 * @param pid  父id，顶级传0
		 */
		initCourseClassify: function () {
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/goodsCategory/listCategory",
				{ pid: 0 },
				null,
				null,
				(successCallResult) => {
					let categoryList = successCallResult.categoryList;
					categoryList.forEach(function (item) {
						item.sortPath = item.path ? item.path : "-1";
					});
					this.firstLevelColumn = categoryList;
					this.loadRightList(8012);
				},
				(errorCall) => {}
			);
		},
		/**
		 * 初始化课程分类 二级
		 * @param pid  父id
		 */
		loadRightList: async function (pid,firstNum) {
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/goodsCategory/listCategory",
				{ pid: pid },
				null,
				null,
				async (successCallResult) => {
					let categoryList = successCallResult.categoryList;
					categoryList.forEach(function (item) {
						item.sortPath = item.path ? item.path : "-1";
					});
					this.secondLevelOneColumn = categoryList;
					this.secondLevelOneColumn.forEach(async (item) => {
						const res = await this.initCourseThirdClassify(item.id);

						let f = res.categoryList.filter((c) => {
							return c.parentName === item.name;
						});
						this.$set(item, "c", f);
					});
				},
				(errorCall) => {}
			);
		},
		/**
		 * 初始化课程分类 三级
		 * @param pid  父id
		 */
		initCourseThirdClassify: async function (pid) {
			return new Promise((resolve, reject) => {
				this.$axiosPackag.getMessageByAxios("POST", "/goodsCategory/listCategory", { pid: pid }, null, null, (successCallResult) => {
					resolve(successCallResult);
				});
			});
		},
		onSearch: function () {
			let param = {};
			param.name = this.value;
			param.number = this.pageNumber;
			param.size = this.pageSize;
			this.$api.get("/web/getGoodsInfoList", param, (res) => {
				if (res.code == "SUCCESS") {
					this.courseCenter = res.data.rows;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		//返回上一步
		onClickLeft() {
			this.$router.go(-1);
		},
		//跳转搜索页
		searchResult() {
			this.$router.push({ path: "/mobileSearchResult" });
		},
		//侧边栏的切换
		changeRightList(pid, firstNum) {
			if (pid == "8012") {
				this.loadRightList(8012,8);
			}else{
                this.loadRightList(pid,'');
            }
		},
		goCurriculum(path) {
			this.$router.push({ path: "/mobileBannerResult", query: { categoryPath: path } });
		},
	},
	created() {
		this.initCourseClassify();
	},
	mounted() {},
};
</script>
<style lang="less" scoped>
.leftClick {
	margin-left: 0.426667rem;
	width: 0.426667rem;
	height: 0.426667rem;
	margin-bottom: 0.213333rem;
}
.leftClick .van-icon img {
	width: 0.426667rem;
	height: 0.426667rem;
}
.van-search__content {
	width: 7.44rem;
	height: 0.853333rem;
	background: #f3f3f5;
	opacity: 1;
	border-radius: 0.48rem;
}
.secondCourse div {
	color: #000000;
	font-weight: bold;
	font-size: 0.426667rem;
}
.secondCourse {
	margin-left: 0.32rem;
	margin-bottom: 0.746667rem;
}
.classname {
	margin-right: 0.213333rem;
	margin-bottom: 0.213333rem;
	padding: 0.16rem 0.266667rem;
	background: #f7f7f7;
	border-radius: 0.106667rem;
	color: #555555;
	font-weight: 400;
	font-size: 0.373333rem;
}
.classnameAll {
	// color: #ffffff;
	font-size: 0.373333rem;
	font-weight: 400;
	// background: #dc0021;
}
.noData {
	display: flex;
	flex-wrap: wrap;
	margin-left: 0.32rem;
	margin-bottom: 0.746667rem;
}
.van-search__action {
	padding-left: 0.32rem;
	padding-right: 0.426667rem;
}
</style>



// WEBPACK FOOTER //
// MobileCourseList.vue?3f9da6ef